<template>
  <div class="container">
    <el-row type="flex">
    <el-select v-model="productSearchQuery.storeId" @change="getProductList()">
      <el-option v-for="item in storeList" :key="item.storeId" :label="item.nickName" :value="item.storeId"></el-option>
    </el-select>
  </el-row>
  <el-row type="flex" justify="center">
    <el-col :span="8">
      <el-table :data="firstProductList" style="width: 100%">
        <el-table-column align="left">
          <template slot-scope="scope">
            <el-button  v-if="scope.row.status === 0" type="success"  @click="editStatus(scope.row)">
            <span class="name">{{scope.row.productName}}</span>
          </el-button>
            <el-button  v-if="scope.row.status === 2" type="danger"  @click="editStatus(scope.row)">
              <span class="name">{{scope.row.productName}}</span>
            </el-button>
            <el-button  v-if="scope.row.status === 3" type="info"  disabled>
              <span class="name">{{scope.row.productName}}</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-col :span="8">
      <el-table :data="secondProductList" style="width: 100%">
        <el-table-column align="left">
          <template slot-scope="scope">
            <el-button  v-if="scope.row.status === 0" type="success"  @click="editStatus(scope.row)">
              <span class="name">{{scope.row.productName}}</span>
            </el-button>
            <el-button  v-if="scope.row.status === 2" type="danger"  @click="editStatus(scope.row)">
              <span class="name">{{scope.row.productName}}</span>
            </el-button>
            <el-button  v-if="scope.row.status === 3" type="info"  disabled>
              <span class="name">{{scope.row.productName}}</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-col :span="8">
      <el-table :data="thirdProductList" style="width: 100%">
        <el-table-column align="left">
          <template slot-scope="scope">
            <el-button  v-if="scope.row.status === 0" type="success"  @click="editStatus(scope.row)">
              <span class="name">{{scope.row.productName}}</span>
            </el-button>
            <el-button  v-if="scope.row.status === 2" type="danger"  @click="editStatus(scope.row)">
              <span class="name">{{scope.row.productName}}</span>
            </el-button>
            <el-button  v-if="scope.row.status === 3" type="info"  disabled>
              <span class="name">{{scope.row.productName}}</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>
</div>
</template>
<style lang="less">
.el-button {
  width: 100%;
}
.name{
  font-size: smaller;
  margin-inline-start: -4vmin;
}
</style>
<script>
import {
  mainten_store_list,
  mainten_product_list,
  edit_mainten_product_status
} from '@/api/offical'
export default {
  name: "package",
  data() {
    return {
      storeList:[],
      productSearchQuery:{storeId:0,openId:''},
      firstProductList: [],
      secondProductList: [],
      thirdProductList: [],
      statusItem: [
        { 'key': 0, 'name': '正常' },
        { 'key': 1, 'name': '维护' },
        { 'key': 2, 'name': '下架' },
      ],
      officalForm: {
        'openId': '',
        'productId': '',
        'status': ''
      }

    }
  },
  created() {
    var openid = '';
    openid = this.$route.query.openId;
    sessionStorage.setItem('openid', openid); // 读
    // sessionStorage.getItem('openid') 取
  },
  methods: {
    async getStoreList(){
      const [res,err] = await mainten_store_list({openId:sessionStorage.getItem('openid')})
      if(err) return
      this.storeList = res.list
      this.productSearchQuery.storeId=res.list[0].storeId
    },
    async editStatus(item) {
      this.officalForm.productId = item.productId
      this.officalForm.status = item.status
      this.officalForm.openId = sessionStorage.getItem('openid')

      if (this.officalForm.status === 0) {
        this.officalForm.status = 2
      }
      else if (this.officalForm.status === 2) {
        this.officalForm.status = 0
      }
      const [res, err] = await edit_mainten_product_status(this.officalForm)
      if (err) return
      this.$message({
        type: 'success',
        message: "成功",
      })
      this.getProductList()
    },
    async getProductList() {
      const {productSearchQuery} = this
      productSearchQuery.openId = sessionStorage.getItem('openid')
      this.firstProductList = []
      this.secondProductList = []
      this.thirdProductList = []
      const [res, err] = await mainten_product_list(productSearchQuery)
      if (err) return
      var newArr = []
      for (var x = 0; x < Math.ceil(res.list.length / 3); x++) {
        var start = x * 3
        var end = start + 3
        newArr.push(res.list.slice(start, end))
      }
      for (var i = 0; i < newArr.length; i++) {
        if (newArr[i].length === 1 && i == newArr.length - 1) {
          this.firstProductList.push(newArr[i][0])
        }
        else if (newArr[i].length == 2 && i == newArr.length - 1) {
          this.firstProductList.push(newArr[i][0])
          this.secondProductList.push(newArr[i][1])
        } else {
          this.firstProductList.push(newArr[i][0])
          this.secondProductList.push(newArr[i][1])
          this.thirdProductList.push(newArr[i][2])
        }
      }

    }

  },
  async mounted() {
    await this.getStoreList()
    await this.getProductList()
  }
}
</script>